module.exports = __webpack_public_path__ + "static/img/4.906c9f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/12.18/4.jpg
// module id = V1od
// module chunks = 1